import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { BuisnessPromotion } from 'src/app/models/common';
import { ApiService } from 'src/app/providers/api.service';
import { SM_CONSTANTS } from '../../constants/sm-constants';

@Component({
  selector: 'sm-add-buisness-post',
  templateUrl: './add-buisness-post.component.html',
  styleUrls: ['./add-buisness-post.component.scss'],
})
export class AddBuisnessPostComponent implements OnInit {
  public buisnessPromotionData: BuisnessPromotion = new BuisnessPromotion();
  public fileName: string = '';
  private _apiSubscription: Subscription = new Subscription();
  public editMode: boolean = false;
  public loader: boolean = false;
  public removable: boolean = true;
  public assetList: any[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA) public parentData: any,
    private _apiService: ApiService,
    private _snackBar: MatSnackBar
  ) {}
  removeAsset() {
    this.buisnessPromotionData.imgUrl = '';
    this.assetList = [];
  }
  ngOnInit(): void {
    console.log(this.parentData.data);
    let data: any = new BuisnessPromotion();
    Object.assign(data, this.parentData.data);
    console.log(data);
    if (data.hash_id) {
      this.assetList.push({
        assetName: data?.imgUrl
          .split('/')
          .pop()
          .substring(data.imgUrl.split('/').pop().lastIndexOf('_') + 1),
        url: data?.imgUrl,
      });
      this.buisnessPromotionData = data;
      this.editMode = true;
    }
    this._apiSubscription = this._apiService.apiResult.subscribe((res) => {
      console.log('Response', res);
      if (res.responseType === SM_CONSTANTS.UPLOAD_RESULT) {
        console.log(res.result);
        this.assetList.push({
          assetName: this.fileName,
          url: res.result?.url,
          thumbnail: res.result?.thumbnail,
        });
        this.buisnessPromotionData.imgUrl = res.result?.url;
        this.loader = false;
      }
      if (
        res.responseType === SM_CONSTANTS.UPDATE_BUISNESS_PROMOTION_INFO_RESULT
      ) {
        if (data) {
          this._snackBar.open('Buisness promo updated successfully', 'Ok', {
            duration: 3000,
          });
        } else {
          this._snackBar.open('Buisness promo added successfully', 'Ok', {
            duration: 3000,
          });
        }
        this.parentData.ref.closeAll();
      }
    });
  }

  ngOnDestroy() {
    this._apiSubscription.unsubscribe();
  }

  onPost() {
    // console.log('Data', this.buisnessPromotionData);
    if (this.buisnessPromotionData.hash_id === '') {
      this.buisnessPromotionData.hash_id = undefined;
    }
    console.log(this.editMode);
    if (!this.editMode) {
      this.buisnessPromotionData['hash_id'] = undefined;
    }

    if (this.buisnessPromotionData.targetCountry === '') {
      if (!this.editMode) {
        this.buisnessPromotionData.targetCountry = undefined;
        this.buisnessPromotionData.targetState = undefined;
        this.buisnessPromotionData.targetCity = undefined;
      } else {
        this.buisnessPromotionData.targetCountry = 'null';
        this.buisnessPromotionData.targetState = 'null';
        this.buisnessPromotionData.targetCity = 'null';
      }
    }
    if (this.buisnessPromotionData.targetState === '') {
      if (!this.editMode) {
        this.buisnessPromotionData.targetCountry = undefined;
        this.buisnessPromotionData.targetState = undefined;
        this.buisnessPromotionData.targetCity = undefined;
      } else {
        this.buisnessPromotionData.targetCountry = 'null';
        this.buisnessPromotionData.targetState = 'null';
        this.buisnessPromotionData.targetCity = 'null';
      }
    }
    if (this.buisnessPromotionData.targetCity === '') {
      if (!this.editMode) {
        this.buisnessPromotionData.targetCountry = undefined;
        this.buisnessPromotionData.targetState = undefined;
        this.buisnessPromotionData.targetCity = undefined;
      } else {
        this.buisnessPromotionData.targetCountry = 'null';
        this.buisnessPromotionData.targetState = 'null';
        this.buisnessPromotionData.targetCity = 'null';
      }
    }
    this.buisnessPromotionData.postType = '5';
    this.buisnessPromotionData['searchType'] = undefined;
    console.log('updated data', {
      promotionInfo: this.buisnessPromotionData,
    });
    this._apiService.updateBuisnessPromotion({
      promotionInfo: this.buisnessPromotionData,
    });
  }

  onUploadImage(event: any) {
    this.loader = true;
    console.log(event.target.files);
    if (event.target.value === '') {
      this.loader = false;
      return;
    }
    this.fileName = event.target.files[0].name;
    let sizeinKb = +event.target.files[0].size / 1000;
    if (sizeinKb > 1021) {
      this._snackBar.open('Image size should not exceed more then 1 mb', 'Ok');
      return;
    }
    let formData: FormData = new FormData();
    formData.append('recfile', event.target.files[0]);
    this._apiService.uploadAssets(formData, 1);
  }

  locationAutoComplete(event: any) {
    console.log('location', event.place.address_components);
    // administrative_area_level_1 = state
    // locality = city
    // country = country
    event.place.address_components?.forEach((data: any) => {
      let type = data.types[0];
      console.log(type);
      if (type === 'administrative_area_level_1') {
        this.buisnessPromotionData.targetState = data?.long_name;
      } else if (type === 'locality') {
        this.buisnessPromotionData.targetCity = data.long_name;
      } else if (type === 'country') {
        this.buisnessPromotionData.targetCountry = data.long_name;
      }
    });
  }
}
